module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/downloadImg-e0619c678222426b03b21e26ab2452db.png";